export default {
      id: "action-icon-cancelled-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "icons.svg#action-icon-cancelled",
      toString: function () {
        return this.url;
      }
    }